export default {"src":"/_next/static/media/library.581f7d05.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};